import i18n from '@/lang' //
import {colorRgba} from "@/utils";

let green = '#28C76F',
  yellow = '#FF9F43',
  grayBg = '#BABFC7',
  grayColor = '#6E6B7B';

export function getStaus(status){
  switch (status) {
    case 0:
      return i18n.t('valid');
    case 1:
      return i18n.t('finished');
    case 2:
      return i18n.t('unsubscribe');
    case 3:
      return  i18n.t('copyMaster.Not_active');
    case 4:
      return  i18n.t('Settlement');
  }
}

export function getStyle(status) {
  if(status === 0){
    return {
      backgroundColor: colorRgba(green,0.12),
      color: green,
    }
  }else {
    return {
      backgroundColor: colorRgba(grayBg,0.12),
      color: grayColor,
    }
  }
};
